module.exports = __webpack_public_path__ + "images/xibao_top_backview_2025.1789440611829.jpg";